// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FL1kd","field":"styles_field__JQ7TD","fieldCol":"styles_fieldCol__2Kfui","diffCol":"styles_diffCol__3C4BC","diff":"styles_diff___zRbi"};